import React from "react";
import "../LayoutCSS/Halloween.css";

const HalloweenOverlay = () => (
    <div>
        <div className="halloween-overlay-background" />
        <div className="halloween-overlay">
            {Array.from({ length: 6 }).map((_, idx) => (
                <div className={`spider_${idx}`} key={idx}>
                    <div className="eye left"></div>
                    <div className="eye right"></div>
                    {Array.from({ length: 4 }).map((_, i) => (
                        <span className="leg left" key={`l${idx}-${i}`}></span>
                    ))}
                    {Array.from({ length: 4 }).map((_, i) => (
                        <span className="leg right" key={`r${idx}-${i}`}></span>
                    ))}
                </div>
            ))}
        </div>
    </div>
);

export default HalloweenOverlay;
